import React, { useEffect, useState } from "react";
import Home from "pages/Home";
import { colors, Grid } from "@mui/material";
import { ReactComponent as GoldIcon } from "assets/icons/Design Card Icon/Goldbar.svg";
import { ReactComponent as LabourIcon } from "assets/icons/Design Card Icon/babor.svg";
import { ReactComponent as BronzeClass } from "assets/icons/Design Card Icon/brozen.svg";
import { ReactComponent as DiamonIcon } from "assets/icons/Design Card Icon/diamond.svg";
import { ReactComponent as SilverClass } from "assets/icons/Design Card Icon/sliver.svg";
import { ReactComponent as GoldClass } from "assets/icons/gold.svg";
import { ReactComponent as SetIcon } from "assets/sidebar/enable/sets.svg";
import RemoveProduct from "components/ui/RemoveModal/RemoveModal";
import { ReactComponent as CalenderIcon } from "assets/icons/Calender.svg";
import TrayModal from "components/ui/TrayModal";
import { Toast, ProductCard } from "components/ui";
import "./collectionproduct.css";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import productData from "db/productsData.json";
import { findSpecificPage, hasAccessPage } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import SortContext from "context/SortContext";
import useProductInCatalogCheck from "hooks/useStockInCatalog";
import useStockInCatalog from "hooks/useStockInCatalog";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, initEditCategory, removeEditCategory, removeFromCart } from "store/cartSlice";

function Product({ product, allData }) {
  // console.log("Collection Child===>>>")
  const { setBtnTitle, btnTitle, presentInCatalog } = useStockInCatalog(product);
  const [showTrayModal, setShowTrayModal] = useState(false);
  const [selectedCartProducts, setSelectedCartProducts] = useState({});
  // const [checkedItems, setcheckedItems] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  // const { setCountCart, countCart, addToCart, removeFromCart } = useGlobalContext();
  const [btn, setBtn] = useState("Select");
  const { isEdit: CollectionEdit, setIsBtnEnable } = React.useContext(SortContext);
  const location = useLocation();
  const innerChnages = location?.state?.innerChnages;
  const isEdit = location?.state?.edit || innerChnages;
  const permission = usePermissions();
  const hasAccessDeleteCollection = hasAccessPage(findSpecificPage("Collection", permission), "archive");

  const dispatch = useDispatch();

  const isInCart = useSelector((state) => state.cart.cartData.some((item) => item.styleNumber === product.styleNumber));

  const handleAddToCartBtn = React.useCallback(() => {
    dispatch(
      addToCart(
        {
          product: selectedCartProducts,
          location: location,
        }
      )


    );
  }, [dispatch, selectedCartProducts]);

  const handleRemoveCart = React.useCallback(() => {
    dispatch(removeFromCart(selectedCartProducts));
  }, [dispatch, selectedCartProducts]);

  useEffect(() => {
    setBtnTitle(isInCart ? "Added" : "Add");
  }, [isInCart, setBtnTitle]);

  // const handleAddToCartBtn = () => {
  //   setBtnTitle("Added");
  //   addToCart(selectedCartProducts);
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  // const handleRemoveCart = () => {
  //   setBtnTitle("Add");
  //   removeFromCart(selectedCartProducts);
  //   sessionStorage.setItem("RecentlyRemoved", JSON.stringify(selectedCartProducts));
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  const handleCloseToast = (Reason) => {
    if (Reason === "clickaway") {
      return;
    }
    setToastOpen(false);
  };

  const toggleDrawer = (open) => {
    setShowTrayModal(open);
  };

  useEffect(() => {
    setSelectedCartProducts(() => ({
      ...product,
      isAddedInCart: true,
    }));
  }, []);

  useEffect(() => {
    dispatch(initEditCategory("RemoveCollectionDesign"));
  }, [dispatch]);

  const selectProd = React.useCallback(() => {
    setBtn("Selected");
  }, [setBtn]);

  const unSelect = React.useCallback(
    (productToRemove) => {
      // setBtn("Select");
      // let getUpdateCatagoryData = JSON.parse(sessionStorage.getItem("RemoveCollectionDesign")) || [];
      // getUpdateCatagoryData = getUpdateCatagoryData.filter((item) => (item.id || item._id) !== productToRemove.id);
      // sessionStorage.setItem("RemoveCollectionDesign", JSON.stringify(getUpdateCatagoryData));
      // window.dispatchEvent(new Event("UpdateSubCategory"));
      // setIsEditCatagoryData(JSON.parse(sessionStorage.getItem("RestrictDesign")) || []);
      setBtn("Select");
      dispatch(
        removeEditCategory({
          storageKey: "RemoveCollectionDesign",
          id: productToRemove.id || productToRemove._id,
        })
      );
    },
    [dispatch, setBtn]
  );

  return (
    <>
      <Grid item className="product">
        <ProductCard
          data={product}
          style={{ maxWidth: isEdit ? "474px" : "474px", minWidth: isEdit ? "474px" : "474px" }}
          selectedCartProducts={selectedCartProducts}
          {...(innerChnages && {
            isBtn: innerChnages,
            addtoCart: handleAddToCartBtn,
            btnTilte: btnTitle,
            removeCart: handleRemoveCart,
            presentInCatalog: presentInCatalog,
          })}
          {...(CollectionEdit === "click" && {
            isBtn: true,
            btnTilte: btn,
            addtoCart: selectProd,
            removeCart: unSelect,
            updateCatagoryData: "RemoveCollectionDesign",
          })}
          allData={allData}
        />
        {/* <Toast
          open={toastOpen}
          msg={`Design Has Been Added To Cart ${countCart} `}
          autoHideDuration={2000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          ContentProps={{
            sx: { backgroundColor: "#50C878" },
          }}
        /> */}
      </Grid>
      <TrayModal cardId={product.id} open={showTrayModal} setOpen={toggleDrawer} trayName={product.gold} />
    </>
  );
}

export default Product;
